.toolbar {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: none;
  height: var(--toolbar-height);
  padding: 0 var(--spacing-md);
  border-bottom: 1px solid var(--color-border);
  background: var(--color-surface);
  box-shadow: var(--shadow-sm);
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: none;
}

.toolbar::-webkit-scrollbar {
  display: none;
}

.group {
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
}

.spacer {
  flex: 1;
  min-width: 0;
}

.brand {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  flex: none;
  padding-right: var(--spacing-sm);
  color: var(--color-primary);
}

.brandName {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-semibold);
  letter-spacing: 0.01em;
  color: var(--color-text);
  white-space: nowrap;
}

/* Below 1440 px the brand text yields its space to the mode tabs. */
@media (max-width: 1439px) {
  .brandName {
    display: none;
  }
}
